import { render, staticRenderFns } from "./ChatboxModalConfirmTextReply.vue?vue&type=template&id=2f96fd2e&scoped=true&"
import script from "./ChatboxModalConfirmTextReply.vue?vue&type=script&lang=js&"
export * from "./ChatboxModalConfirmTextReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatboxModalConfirmTextReply.vue?vue&type=style&index=0&id=2f96fd2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96fd2e",
  null
  
)

export default component.exports